/**
 * Created by natalia.petrov on 8/1/2017.
 */
export default {
    GET_NEWS:'GET_NEWS',
    NEWS:'NEWS',
    HAS_UNREAD:'HAS_UNREAD',
    OPEN_CLOSED_CLASS_INDEX:'OPEN_CLOSED_CLASS_INDEX',
    UPDATE_NEWS_CONTEXT:'UPDATE_NEWS_CONTEXT',
    NEWS_CONTEXT:'NEWS_CONTEXT'
}


// WEBPACK FOOTER //
// ./constants/news.js